export enum DictationErrorKind {
    Microphone = 'microphone',
    StartFailed = 'startFailed',
    Interrupted = 'interrupted',
    IdleTimeout = 'idleTimeout',
}

export type DictationPhase = 'idle' | 'starting' | 'active';

export interface DictationFieldBinding {
    fieldId: string;
    getText(): string;
    setText(text: string): void;
}

export interface DictationState {
    activeFieldId: string | null;
    phase: DictationPhase;
    error: { fieldId: string; kind: DictationErrorKind } | null;
    failedUtteranceFieldId: string | null;
}
